import { render, staticRenderFns } from "./ListGames.vue?vue&type=template&id=8b7106c0&scoped=true&"
import script from "./ListGames.vue?vue&type=script&lang=js&"
export * from "./ListGames.vue?vue&type=script&lang=js&"
import style0 from "./ListGames.vue?vue&type=style&index=0&id=8b7106c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7106c0",
  null
  
)

export default component.exports